const i18n = {
  'zh-CN': {
    therequestfailed: '请求失败',
    backMall: '导入/导出',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: '删除成功',
    selectedInformation: '确定删除所选信息吗?',
    loading: '加载中',
    operateSuccessfully: '操作成功',
    personCharge: '请选择负责人',
    confirmAddress: '请求地址错误,请确认地址!',
    dontHave: '您没有【',
    operationOfThe: '】的【查看列表】操作的功能权限，请联系管理员。',
    chooseData: '选择数据'
  },
  'en': {
    therequestfailed: 'Request failed',
    backMall: 'Import/Export',
    currentlist: 'All the data of the current list will be exported for you',
    currentFilter: 'All the data of the current filtered result will be exported for you',
    tip: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteInformation: 'Confirm to delete the information?',
    successfullyDelete: 'Deleted successfully',
    selectedInformation: 'Confirm to delete the selected information?',
    loading: 'Loading',
    operateSuccessfully: 'Operation succeeded',
    personCharge: 'Please select the person in charge',
    confirmAddress: 'Incorrect address requested. Please confirm the address!',
    dontHave: 'You have no [',
    operationOfThe: '] [View List] operation function permissions. Please contact the administrator.',
    chooseData: 'Select Data'
  }
}
export default i18n
